import { QueryClientProvider } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { RouterProvider } from "react-router";
import { useNotificationClicks } from "../features/notifications/hooks/usePushNotifications";
import { createAppRouter } from "../routes/router";
import { createQueryClient } from "./queryClient";

export function App() {
  const [queryClient] = useState(createQueryClient);
  const [router] = useState(createAppRouter);
  // Clicking a push notification opens its page in this tab, without reloading the app.
  useNotificationClicks(
    useCallback(
      (url: string) => {
        void router.navigate(url);
      },
      [router],
    ),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
